module.exports = __webpack_public_path__ + "e54e5b498c095f376f73484e1d95a0cd.woff2";